import { Component, OnInit} from '@angular/core';
import { MeterService } from 'projects/pplus/src/lib/components/elements/meter/meter.service';

@Component({
  selector: 'app-selfview-meter-data-download',
  templateUrl: './selfview-meter-data-download.component.html',
  styleUrls: ['./selfview-meter-data-download.component.scss'],
  providers: [MeterService]
})
export class SelfviewMeterDataDownloadComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {
  }
}
